<template>
  <nav class="main-nav" aria-label="Main Navigation">
    <ul ref="menuContainerRef" class="main-nav__menu" role="menubar">
      <MegaMenuRootItem v-for="(rootItem, index) in nav.main" :key="`root-item-${index}`" :item="rootItem" :route="route" />
    </ul>
    <hr />
    <ul class="main-nav__secondary" role="menubar">
      <MegaMenuRootItem v-for="(rootItem, index) in nav.secondary" :key="`root-secondary-item-${index}`" :item="rootItem" :route="route" />
    </ul>
  </nav>
</template>

<script lang="ts" setup>
import MegaMenuRootItem from '~/components/ui/layout/mega-menu/MegaMenuRootItem.vue';
import { ref } from 'vue';
import { useLayoutNavStore } from '~/stores/layout-nav';

const route = useRoute();

const props = defineProps({
  nav: {
    type: Object,
    required: true,
  },
});

const layoutNavStore = useLayoutNavStore();
const menuContainerRef = ref<HTMLElement | null>(null);
let menuAimInstance: ReturnType<typeof useMenuAim> | null = null;

onMounted(() => {
  const elements: HTMLElement[] = menuContainerRef.value
    ? Array.from(menuContainerRef.value.children).filter((n): n is HTMLElement => n instanceof HTMLElement)
    : [];

  menuAimInstance = useMenuAim(elements, {
    exitDelay: 300,
    interval: 100,
    sensitivity: 7,
    onEnter: (el) => {
      if (!el.classList.contains('has-sub')) return;

      const index = elements.indexOf(el);
      const currentEl = props.nav.main[index];
      document.documentElement.classList.add('is-nav-over');
      layoutNavStore.toggleOpenedNavItem(currentEl);
    },
    onExit: () => {
      document.documentElement.classList.remove('is-nav-over');
      layoutNavStore.toggleOpenedNavItem(null);
    },
  });
});

onUnmounted(() => {
  if (menuAimInstance) menuAimInstance.destroy();
});
</script>
